export default __webpack_public_path__ + "static/media/554f14eef48027ca.d6d1083c1ae304579ae1bdc8efa3169b.svg";